import type { ClientExperimentConfig } from './client'

/**
 * CLIENT EXPERIMENTS CONFIGURATION
 *
 * Add client-side experiments here. Each entry auto-generates methods:
 * - get{Name}Assignment() - logs exposure
 * - peek{Name}Assignment() - doesn't log exposure
 *
 * Navigation: getExampleExperimentAssignment() → search for "exampleExperiment:"
 *
 * Example:
 *   myExperiment: {
 *     experimentId: 'my_experiment',
 *     variants: ['control', 'test'] as const,
 *     eligibility: (ctx) => {
 *       const user = ctx.userService.currentUser
 *       return user != null && !user.isAnonymous
 *     },
 *   }
 */
export const clientExperimentsConfig = {
  exampleExperiment: {
    experimentId: 'example_experiment',
    variants: ['control', 'test'] as const,
    eligibility: (ctx) => {
      const user = ctx.userService.currentUser
      return user != null && !user.isAnonymous
    },
  },
} as const satisfies Record<string, ClientExperimentConfig>
